import { render, staticRenderFns } from "./PatientDetails.vue?vue&type=template&id=06920b0e"
import script from "./PatientDetails.vue?vue&type=script&lang=js"
export * from "./PatientDetails.vue?vue&type=script&lang=js"
import style0 from "./PatientDetails.vue?vue&type=style&index=0&id=06920b0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports